import { config } from "./config";
import axios from "axios";
import utils from "../utils";

let uptimeApi = {};

uptimeApi.getDowntimeList = (limit) => {
  return axios.post(`${config.url}/webmaster/downtime/list`, {limit}, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

uptimeApi.getDowntimeListGraph = (id, chartTime) => {
  const formData = {
    domain_id: id,
    chart_time: chartTime
  }
  return axios.post(`${config.url}/webmaster/downtime/graph`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

uptimeApi.getDowntime = (domain) => {
  const formData = {
    domain: domain
  }
  return axios.post(`${config.url}/webmaster/downtime/check`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

uptimeApi.removeDowntime = (domain_id) => {
  return axios.get(`${config.url}/webmaster/downtime/${domain_id}/delete`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

uptimeApi.saveDowntime = (domain) => {
  const formData = {
    domain: domain,
    tag: "Cloud"
  }
  return axios.post(`${config.url}/webmaster/downtime/store`, formData, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

uptimeApi.downtimeStatus = () => {
  return axios.get(`${config.url}/webmaster/downtime/status`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

export default uptimeApi;
